$(function () {
  const tabs = $('.policy .nav-container .nav-tabs li')
  const tabName = window.location.hash
  const activeTab = tabs.find(`a[href="${tabName}-policy"]`)
  // console.log('activeTab', activeTab, tabs, tabName)
  activeTab.tab('show')
  activeTab.parent().addClass('active')
})
